import { render, staticRenderFns } from "./FloatingView2.vue?vue&type=template&id=5a020acb&scoped=true"
import script from "./FloatingView2.vue?vue&type=script&lang=js"
export * from "./FloatingView2.vue?vue&type=script&lang=js"
import style0 from "./FloatingView2.vue?vue&type=style&index=0&id=5a020acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a020acb",
  null
  
)

export default component.exports